module.exports = {
    contentTypes:
      [
        {
          type: 'stream',
          name: 'Streams',
          description: 'Choose a layout that can categorise your Streams and group them in the most relevant way.',
        },
        {
          type: 'collection',
          name: 'Collections',
          description: 'Choose a layout that can showcase your pre-designed Collections in the best light.',
        }, 
        {
          type: 'asset',
          name: 'Assets',
          description: 'Choose a layout that can enable easy discovery of Assets on your Hub.',
        }
      ]
  };
  